const monthsInAYear = 12

export const calculateYearlyProductMinimumPrice = (
  yearlyPrice: number,
  terminationMonths: number,
): number =>
  yearlyPrice > 0 && terminationMonths > 0
    ? (yearlyPrice / monthsInAYear) * terminationMonths
    : 0
